import hrLang from './lang/hr/all'

interface Itranslations {
    [s:string]:{ [s: string]: string }
}

export enum Language {
    HR = 'hr',
}

export const translations:Itranslations = {
    [Language.HR]: hrLang,
}
